export const localize = (key: string, getState: any): string => {
  const locale = getState()?.userData?.user?.locale || null;
  const texts = getState()?.appData?.texts?.entities[locale] || null;
  return texts[key];
};
